import React, { PropTypes } from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import TransactionType from '../../coverNoteCVComponent/transactionType/TransactionType';
import InsuredName from '../../coverNoteCVComponent/insuredName/InsuredName';
import BusinessType from '../../coverNoteCVComponent/businessType/BusinessType';
import InsuredType from '../../coverNoteCVComponent/insuredType/InsuredType';
import AgentCodeName from '../../coverNoteCVComponent/agentCodeName/AgentCodeName';
import IdNo from '../../coverNoteCVComponent/idNo/IdNo';

const CoverNoteEntry = (props) => {
  return (
    <div className="ebaoUtil__Top-Bottom-Line">
      <h3 className="ebaoUtil__HeaderThree">Cover Note Entry</h3>
      <FormGroup>
        <Col sm={6}>
          <TransactionType
            transactionType={props.coverNoteEntry.transactionType}
            handleChangeTransactionType={props.handleChangeCoverNoteEntry}
          />
        </Col>
        <Col sm={6}>
          <InsuredName
            insuredName={props.coverNoteEntry.insuredName}
            handleChangeInsuredName={props.handleChangeCoverNoteEntry}
          />
        </Col>
      </FormGroup>
      <FormGroup>
        <Col sm={6}>
          <BusinessType
            businessType={props.coverNoteEntry.businessType}
            handleChangeBusinessType={props.handleChangeCoverNoteEntry}
            role={props.role}
          />
        </Col>
        <Col sm={6}>
          <InsuredType
            insuredType={props.coverNoteEntry.insuredType}
            handleChangeInsuredType={props.handleChangeCoverNoteEntry}
          />
        </Col>
      </FormGroup>
      <FormGroup controlId="quotationDateIdNo">
        <Col sm={6}>
          <AgentCodeName
            agentCode={props.coverNoteEntry.agentCode}
            agentName={props.coverNoteEntry.agentName}
            handleGetAgentName={props.handleGetAgentName}
            handleChangeAgentCode={props.handleChangeAgentCode}
            systemRole={props.role}
          />
        </Col>
        <Col sm={6}>
        <IdNo
          id={props.coverNoteEntry.id}
          handleChangeIdNo={props.handleChangeCoverNoteEntry}
          required={props.idNoRequired}
        />
        </Col>
      </FormGroup>
    </div>
  )
}

CoverNoteEntry.propTypes = {
  coverNoteEntry: PropTypes.object,
  handleChangeCoverNoteEntry: PropTypes.func,
  handleGetAgentName: PropTypes.func,
  handleChangeAgentCode: PropTypes.func,
  idNoRequired: PropTypes.bool,
  role: PropTypes.string
};

export default CoverNoteEntry;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/coverNoteEntry/CoverNoteEntry.js